import { Controller, useFormContext } from "react-hook-form";
import { Button, Input, Modal } from "components";
import { useToggle } from "utils";
import { TbInfoCircle } from "react-icons/tb";
import { FormReturnItemsType } from "../types";
import InvoiceDetail from "../../Invoice/components/Detail";

export function LinkToInvoice(): JSX.Element {

    const { control, getValues } = useFormContext<FormReturnItemsType>()
    const salesOrderId = getValues("sales_order_id")
    const invoiceId = getValues("invoice_id")

    return (
        <section className="flex items-end">
            <section className="grow">
                <Controller
                    control={control}
                    name="link"
                    render={({ field }) => (
                        <Input disabled label="LINK" defaultValue={field.value} />
                    )}
                />
            </section>
            <DetailSection
                sales_order_id={salesOrderId?.toString()}
                invoice_id={invoiceId?.toString()}
            />
        </section>
    )
}

export function DetailSection(props: {
    sales_order_id?: string,
    invoice_id?: string
}) {
    const { isActive, toggle } = useToggle(false)

    return (
        <>
            <Button
                type="button"
                color="primary"
                onClick={toggle}
            >
                <TbInfoCircle />
            </Button>

            {isActive && (
                <Modal
                    isOpen
                    title="INVOICE DETAIL"
                    closeModal={toggle}
                >
                    <Modal.Body>
                        <InvoiceDetail
                            sales_order_id={props.sales_order_id!.toString()}
                            invoice_id={props.invoice_id!.toString()}
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    )
}